import { useEffect, useState } from "react";
import { IP } from "../../../internalServer";
import { hasFeature } from "../../../Utils/features";
import { iconData } from "../../../iconData";
import { FaRegEye, FaArrowRight } from "react-icons/fa";

const RotatingNotices = ({ noticeData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [zoomedImage, setZoomedImage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const attachformat = (para) => {
    if (para !== undefined) {
      const filePath = para;
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const extractedFileName = fileName.split("_")[1];
      return extractedFileName;
    }
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  const hasNoticeFeature = hasFeature("NB_MGT");

  const getExtension = (file) => file?.split(".").pop()?.toLowerCase();

  const isImage = (ext) => ["jpg", "jpeg", "png"].includes(ext);

  const isPdf = (ext) => ext === "pdf";
  const isVideo = (ext) => ext === "mp4";

  useEffect(() => {
    if (!noticeData || noticeData.length === 0) return;

    const interval = setInterval(() => {
      setIsAnimating(true); // start exit animation

      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % noticeData.length);
        setIsAnimating(false); // reset for entrance animation
      }, 400); // match out animation duration
    }, 5000);

    return () => clearInterval(interval);
  }, [noticeData]);

  if (!noticeData || noticeData.length === 0) {
    return (
      <div className="container-fluid m-0 fw-medium position-relative overflow-hidden px-3 py-1">
        <div className="row">
          <div className="col-12 d-flex align-items-center">
            <strong className="me-2">Notice:</strong>
            <span className="fw-medium">No Notice Available</span>
          </div>
        </div>
      </div>
    );
  }

  const noticeText =
    noticeData[currentIndex]?.notice.substring(0, 400) + "..." || "";


  return (
    <div className="container-fluid m-0 fw-medium position-relative overflow-hidden  py-2 me-5">
      <div className="row">
        <div className="col-12 d-flex align-items-start">
          <strong className="me-2">Notice:</strong>

          <div
            className="flex-grow-1 w-100 fw-medium"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedNotice(noticeData[currentIndex]);
              setShowModal(true);
            }}
          >
            {/* First Part - only 3 lines */}
            <div
              className={`${isAnimating ? "notice-exit" : "notice-enter"}`}
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                lineHeight: "1.5",
                wordBreak: "break-word",
              }}
            >
              {noticeText}
            </div>
            {noticeText && <div
              className="mt-2 d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill"
              style={{
                background: "#eef4ff",
                color: "#0d6efd",
                fontSize: "14px",
                fontWeight: 600,
                width: "fit-content",
                transition: "0.3s",
              }}
            >
              <FaRegEye />
              <span>Click for more details</span>
              <FaArrowRight size={12} />
            </div>}
          </div>
        </div>
        {showModal && selectedNotice && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              width: "100vw",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={() => setShowModal(false)}
          >
            <div style={{ position: "relative", paddingTop: "50px" }}>
              {/* Close Button Outside Modal */}
              <button
                onClick={() => setShowModal(false)}
                style={{
                  position: "absolute",
                  top: "25px",
                  right: "65px",
                  background: "#fff",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  border: "1px solid #ddd",
                  borderRadius: "50%", // fully rounded
                  width: "30px",
                  height: "30px",
                  fontSize: "16px",
                  lineHeight: "1",
                  textAlign: "center",
                  padding: 0,
                  cursor: "pointer",
                  zIndex: 10,
                  color: "#F77F00",
                }}
              >
                &times;
              </button>

              {/* Modal Box */}
              <div
                style={{
                  backgroundColor: "#fff",
                  width: "1300px",
                  maxWidth: "85%",
                  minHeight: "380px",
                  maxHeight: "80vh",
                  overflowY: "auto",
                  borderRadius: "15px",
                  padding: "20px",
                  position: "relative",
                  margin: "0 auto", // center it
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Modal Body */}
                <div>
                  <textarea
                    readOnly
                    className="form-control"
                    rows={8}
                    style={{
                      border: "2px solid orange",
                      resize: "none",
                      borderRadius: "10px",
                      padding: "10px",
                      fontSize: "16px",
                      width: "100%",
                    }}
                    value={selectedNotice.notice}
                  ></textarea>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: "20px", // Adds gap between image section and link
                      flexWrap: "wrap", // Allows wrapping on smaller screens
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Image Attachments */}
                    {selectedNotice.attachments &&
                    selectedNotice.attachments.length > 0 ? (
                      <div style={{ flex: "1", minWidth: "200px" }}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                            maxHeight: "160px",
                            overflowY: "auto",
                            padding: "5px",
                          }}
                        >
                          {selectedNotice.attachments.map((attachment, i) => {
                            const ext = getExtension(attachment);

                            return (
                              <div key={i} style={{ width: "120px" }}>
                                {isImage(ext) ? (
                                  <img
                                    src={`${IP}${attachment}`}
                                    alt={`attachment-${i}`}
                                    onClick={() =>
                                      setZoomedImage(`${IP}${attachment}`)
                                    }
                                    style={{
                                      width: "120px",
                                      height: "80px",
                                      borderRadius: "5px",
                                      objectFit: "cover",
                                      border: "1px solid #ddd",
                                      cursor: "pointer",
                                    }}
                                  />
                                ) : isPdf(ext) ? (
                                  <div
                                    className="d-flex align-items-center gap-1"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleClickforpdf(attachment)
                                    }
                                  >
                                    <img
                                      style={{ width: "70px" }}
                                      src={
                                        iconData?.find(
                                          (i) => i.extension === ext,
                                        )?.icon
                                      }
                                      alt=""
                                    />
                                    <div>{attachformat(attachment)}</div>
                                  </div>
                                ) : isVideo(ext) ? (
                                  <div
                                    className="d-flex align-items-center gap-1"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      setZoomedImage(`${IP}${attachment}`)
                                    }
                                  >
                                    <img
                                      style={{ width: "70px" }}
                                      src={
                                        iconData?.find(
                                          (i) => i.extension === "mp4",
                                        )?.icon
                                      }
                                      alt="video"
                                    />
                                    <div>{attachformat(attachment)}</div>
                                  </div>
                                ) : (
                                  <img
                                    style={{ width: "70px" }}
                                    src={
                                      iconData?.find((i) => i.extension === ext)
                                        ?.icon
                                    }
                                    alt="Icon"
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <p className="text-danger mt-2">No Attachment Found!!</p>
                    )}

                    {/* Embedded Link */}
                    {selectedNotice.embedded_link ? (
                      <div style={{ flexShrink: 0, maxWidth: "40%" }}>
                        <a
                          className="link"
                          href={
                            selectedNotice.embedded_link.includes("http")
                              ? selectedNotice.embedded_link
                              : `https://${selectedNotice.embedded_link}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p
                            className="notice_Link text-break mb-0"
                            style={{
                              wordBreak: "break-word",
                              fontWeight: "500",
                            }}
                          >
                            {selectedNotice.embedded_link}
                          </p>
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .notice-enter {
          animation: slideIn 0.4s ease forwards;
        }

        .notice-exit {
          animation: slideOut 0.4s ease forwards;
          color: gray;
        }

        @keyframes slideIn {
          0% {
            opacity: 0;
            transform: translateY(10px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideOut {
          0% {
            opacity: 1;
            transform: translateY(0);
          }
          100% {
            opacity: 0;
            transform: translateY(-10px);
          }
        }
      `}</style>
    </div>
  );
};

export default RotatingNotices;
